
import { int } from "@goodgamestudios/math-utilities";
import { Poker2Model } from "../../model/Poker2Model";
import { AniTableHelper } from "./AniTableHelper";
import { CardHelper } from "./CardHelper";

import { NumberStringHelper } from "../../helper/NumberStringHelper";

import MovieClip = createjs.MovieClip;
import Container = createjs.Container;

export class OnTableHelper {
    private _tableMC: MovieClip;
    private dealer: Library.PokerTable.Dealer;
    private communityCardPositions: any[];
    private MAX_SEATS: number = 9;
    private CHIP_SCALE: number = 0.2;
    private CARD_WIDTH: number = 70;
    private COMMUNITY_CARD_HEIGHT: number = 50;
    private COMMUNITY_CARD_WIDTH: number = 40;
    private COMMUNITYCARD_SPACE: number = 25;
    private DEALERPOS_X: number = 40;
    private DEALERPOS_Y: number = 0;
    private CARD_STACK_X: number = 239;
    private CARD_STACK_Y: number = 0;

    constructor(tableMC: MovieClip) {
        this.tableMC = tableMC;
    }

    public get tableMC(): MovieClip {
        return this._tableMC;
    }

    public set tableMC(value: MovieClip) {
        this._tableMC = value;
    }

    public clearTable(): void {
        this.clearPot();
        this.clearCommunityCards();
        for (var i: number = 0; i < this.MAX_SEATS; i++)
            this.clearBet(this.tableMC["mc_bet_" + i] as MovieClip);
    }

    public drawDealer(index: number, aniHelper: AniTableHelper): void {
        this.clearDealer();
        this.tableMC.mc_dealer.addChild(new Library.PokerTable.Dealer());
        aniHelper.posDealer(index, true, this.tableMC.mc_dealer, this.getDealerPositions());
    }

    private getDealerPositions(): any[] {
        var positionAry: any[] = new Array();
        for (var i: number = 0; i < this.MAX_SEATS; i++) {
            var betContainer: MovieClip = this.tableMC["mc_bet_" + i] as MovieClip;
            positionAry[i] = [betContainer.x + this.DEALERPOS_X, betContainer.y + this.DEALERPOS_Y];
        }
        return positionAry;
    }

    public drawPot(cashPot: number, aniHelper: AniTableHelper, animation: boolean = true): void {
        // von den Spielern zum Pot hin animieren
        if (animation) {
            for (var i: number = 0; i < this.MAX_SEATS; i++)
                aniHelper.animationChips2PotOnePlayer(this.tableMC["mc_bet_" + i], this.tableMC.mc_pot);
        }

        this.clearPot();
        var chips: Library.PokerTable.Chips = new Library.PokerTable.Chips();
        chips.scaleX = chips.scaleY = this.CHIP_SCALE;
        this.tableMC.mc_pot.mc_holder.addChild(chips);
        // Pottext aktualisieren und Chipsgrafik entsprechend der Chipssumme anzeigen
        this.tableMC.mc_pot.txt_amount.text = (cashPot > 0) ? NumberStringHelper.groupString(cashPot, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData)) : "";

        aniHelper.setChipsWert2Chips(chips, cashPot);
    }

    public drawCommunityCards(cards: any[], aniHelper: AniTableHelper, animation: boolean, delay: number = 2, isShowdown: boolean = false, highlightCards: any[] = null): void {
        var numChildren: number = int(this.tableMC.mc_cardholder.numChildren);
        var startpos: number = 0;

        if (cards.length == 3 || numChildren == 0)
            startpos = 0;
        else if (isShowdown) {
            startpos = int(cards.length - Poker2Model.onTableData.showdownCommunitycards.length);
        }
        else {
            startpos = int((cards.length - 1));
        }

        if (highlightCards || !animation) {
            this.clearCommunityCards();
            startpos = 0;
        }

        var card: Container;
        for (var i: number = startpos; i < cards.length; i++) {
            card = CardHelper.drawCard(cards[i], this.COMMUNITY_CARD_HEIGHT, this.COMMUNITY_CARD_WIDTH, highlightCards);
            this.tableMC.mc_cardholder.addChild(card);
            // Karten positionieren
            card.x = (this.communityCardPositions.length * (this.CARD_WIDTH - this.COMMUNITYCARD_SPACE));
            // Position merken für Animation
            this.communityCardPositions.push(card.x);
        }

        if (!highlightCards && animation) {
            // animate cards
            if (cards.length == 3 || numChildren == 0) {
                for (var cardIndex: number = 0; cardIndex < cards.length; cardIndex++)
                    this.animationComunityCards(aniHelper, this.tableMC.mc_cardholder, cardIndex, cardIndex / delay);
            }
            else if (isShowdown) {
                var cardsOnShowdownTable: number = int(cards.length - Poker2Model.onTableData.showdownCommunitycards.length);
                for (var a: number = cardsOnShowdownTable; a < cards.length; a++)
                    this.animationComunityCards(aniHelper, this.tableMC.mc_cardholder, a, a / 4);
            }
            else {
                this.animationComunityCards(aniHelper, this.tableMC.mc_cardholder, (this.communityCardPositions.length - 1));
            }
        }
    }

    public drawCommunityCardsForRabbitCam(cards: any[], aniHelper: AniTableHelper, animation: boolean, delay: number = 2): void {
        var numChildren: number = int(this.tableMC.mc_cardholder.numChildren);
        var startpos: number = 0;

        // calculate start index
        startpos = int(cards.length - Poker2Model.onTableData.showdownCommunitycards.length);

        var card: Container;
        //			var shadowfilter:DropShadowFilter = new DropShadowFilter(0, 45, 0xffffff, 0.7, 4, 4, 900);
        for (var i: number = startpos; i < cards.length; i++) {
            card = CardHelper.drawCard(cards[i], this.COMMUNITY_CARD_HEIGHT, this.COMMUNITY_CARD_WIDTH);
            // mark card with an alpha as a rabbit cam card
            card.alpha = 0.5;
            //				card.filters = [shadowfilter];

            this.tableMC.mc_cardholder.addChild(card);
            // set position
            card.x = (this.communityCardPositions.length * (this.CARD_WIDTH - this.COMMUNITYCARD_SPACE));
            // store position for animation
            this.communityCardPositions.push(card.x);
        }

        if (animation) {
            var cardIndex: number = 0;

            var cardsOnShowdownTable: number = int(cards.length - Poker2Model.onTableData.showdownCommunitycards.length);
            for (var a: number = cardsOnShowdownTable; a < cards.length; a++) {
                this.animationComunityCards(aniHelper, this.tableMC.mc_cardholder, a, a / 4);
            }
        }
    }

    public drawTutorialCommunityCards(cards: any[], aniHelper: AniTableHelper, animation: boolean, highlightCards: any[] = null): void {
        var numChildren: number = int(this.tableMC.mc_cardholder.numChildren);
        var startpos: number = 0;
        if (cards.length == 3 || numChildren == 0)
            startpos = 0;
        else
            startpos = int((cards.length - 1));

        if (highlightCards || !animation) {
            this.clearCommunityCards();
            startpos = 0;
        }
        // Karten zeichnen
        var card: Container;
        for (var i: number = startpos; i < cards.length; i++) {
            card = CardHelper.drawCard(cards[i], this.COMMUNITY_CARD_HEIGHT, this.COMMUNITY_CARD_WIDTH, highlightCards);
            this.tableMC.mc_cardholder.addChild(card);
            // Karten positionieren
            card.x = (this.communityCardPositions.length * (this.CARD_WIDTH - this.COMMUNITYCARD_SPACE));
            // Position merken für Animation
            this.communityCardPositions.push(card.x);
        }

        if (!highlightCards && animation) {
            // Karten animieren
            if (cards.length == 3 || numChildren == 0)
                for (var cardIndex: number = 0; cardIndex < cards.length; cardIndex++)
                    this.animationComunityCards(aniHelper, this.tableMC.mc_cardholder, cardIndex, cardIndex / 2);
            else
                this.animationComunityCards(aniHelper, this.tableMC.mc_cardholder, (this.communityCardPositions.length - 1));
        }
    }

    private animationComunityCards(aniHelper: AniTableHelper, itemholder: MovieClip, i: number, delay: number = 0): void {
        var child: MovieClip = itemholder.getChildAt(i) as MovieClip;
        child.x = this.CARD_STACK_X;
        child.y = this.CARD_STACK_Y;
        aniHelper.animationcommunityCard(this.tableMC.mc_cardholder.y + 3, this.communityCardPositions[i], child, delay);
    }

    public potAnimation(aniHelper: AniTableHelper): void {
        for (var i: number = 0; i < this.MAX_SEATS; i++)
            aniHelper.animationChips2PotOnePlayer(this.tableMC["mc_bet_" + i], this.tableMC.mc_pot);
    }

    public drawBet(index: number, chipsValue: number, aniHelper: AniTableHelper): void {
        var betContainer: MovieClip = this.tableMC["mc_bet_" + index] as MovieClip;
        this.clearBet(betContainer);

        if (chipsValue > 0) {
            betContainer.txt_amount.text = NumberStringHelper.groupString(chipsValue, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
            var chips: Library.PokerTable.Chips = new Library.PokerTable.Chips();
            chips.scaleX = chips.scaleY = this.CHIP_SCALE;
            betContainer.mc_holder.addChild(chips);
            aniHelper.setChipsWert2Chips(chips, chipsValue);
        }

        if (this.tutorialController.isActive) {
            switch (this.tutorialController.tutorialState) {
                case "tut_step7_smallBlind":
                    // Der Spieler links neben dem Dealer
                    if (index == 1)
                        this.layoutManager.tutPanel.showSpotlight(betContainer.mc_holder);
                    break;
                case "tut_step8_bigBlind":
                    this.layoutManager.tutPanel.showSpotlight(betContainer.mc_holder);
                    break;
            }
        }

    }

    private clearBet(betContainer: MovieClip): void {
        while (betContainer.mc_holder.numChildren > 0)
            betContainer.mc_holder.removeChildAt(0);
        betContainer.txt_amount.text = "";
    }
    public clearDealer(): void {
        while (this.tableMC.mc_dealer.numChildren > 0)
            this.tableMC.mc_dealer.removeChildAt(0);
    }
    public clearCommunityCards(): void {
        this.communityCardPositions = [];
        while (this.tableMC.mc_cardholder.numChildren > 0)
            this.tableMC.mc_cardholder.removeChildAt(0);
    }
    public clearPot(): void {
        while (this.tableMC.mc_pot.mc_holder.numChildren > 0)
            this.tableMC.mc_pot.mc_holder.removeChildAt(0);
        this.tableMC.mc_pot.txt_amount.text = "";
    }

    protected get tutorialController(): Poker2TutorialController {
        return Poker2TutorialController.getInstance();
    }

    protected get layoutManager(): Poker2LayoutManager {
        return Poker2LayoutManager.getInstance();
    }
}
import { Poker2TutorialController } from "../../controller/Poker2TutorialController";
import { Poker2LayoutManager } from "../Poker2LayoutManager";
